import { WORKBENCH_URL } from '@/config/hosts';

export function goLogin() {
  window.open(`${WORKBENCH_URL}/login`, '_self');
}
